// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  loading: 'Die Änderung wird geladen…',
  load_failed: 'Ich konnte diese Änderung nicht laden.',
  load_retry: 'Erneut versuchen',
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Das war schon freigegeben, es war nichts mehr zu tun.',
  action_failed: 'Das hat nicht geklappt, es wurde nichts geändert. Versuch es gleich noch mal.',
  removed: 'Entfernt',
  retry: 'Erneut versuchen',
  retry_one: '{{name}} erneut versuchen',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Freigegeben.',
    retried: 'Erneut versucht.',
    rejected: 'Abgelehnt.',
  },
  done: {
    summary_one: 'Erledigt. {{count}} Änderung übernommen.',
    summary_other: 'Erledigt. {{count}} Änderungen übernommen.',
    skipped_one: '{{count}} übersprungen, dort hat sich nichts geändert.',
    skipped_other: '{{count}} übersprungen, dort hat sich nichts geändert.',
  },
  partial: {
    summary_one: '{{applied}} von {{approved}} Änderungen übernommen, {{count}} nicht.',
    summary_other: '{{applied}} von {{approved}} Änderungen übernommen, {{count}} nicht.',
    detail_one: 'Die {{applied}} sind gespeichert. Bei der {{count}} unten hat sich nichts geändert.',
    detail_other: 'Die {{applied}} sind gespeichert. Bei den {{count}} unten hat sich nichts geändert.',
  },
  stale: {
    summary: '{{applied}} von {{approved}} Änderungen übernommen.',
    detail_one: '{{count}} wurde inzwischen von jemand anderem geändert.',
    detail_other: '{{count}} wurden inzwischen von jemand anderem geändert.',
    reason:
      '{{name}} hat das um {{time}} auf {{value}} geändert, bevor du freigegeben hast, deshalb habe ich es nicht übernommen. Hier noch mal ausgehend vom neuen Wert:',
  },
  undone: {
    summary_one: 'Rückgängig gemacht. Die {{count}} Änderung ist wieder wie vorher.',
    summary_other: 'Rückgängig gemacht. Die {{count}} Änderungen sind wieder wie vorher.',
    detail: 'Auch das steht im Amigo-Protokoll und im Bearbeitungsverlauf.',
  },
  summary: {
    average: '{{amount}} pro Gericht im Schnitt',
    needs_look: 'Bitte prüfen',
    nothing_else: 'Sonst ändert sich nichts',
  },
  labels: {
    waiting: 'Wartet auf Freigabe',
    skip: 'Überspringen',
    unskip: 'Doch übernehmen',
    approve_all: 'Alle freigeben',
    approve_one: '{{count}} freigeben',
    approve_other: '{{count}} freigeben',
    approve_row: 'Freigeben',
    reject: 'Ablehnen…',
    reject_confirm: 'Ablehnen',
    back: 'Zurück',
    why: {
      amigo: 'Warum nicht? (optional, Amigo liest das)',
      assistant: 'Warum nicht? (optional, der Assistent liest das)',
    },
    hint: 'Oder antworte unten, um etwas zu ändern.',
    show_all_one: 'Alle {{count}} Änderungen zeigen',
    show_all_other: 'Alle {{count}} Änderungen zeigen',
    show_less: 'Weniger zeigen',
    applying_one: '{{count}} Änderung wird übernommen…',
    applying_other: '{{count}} Änderungen werden übernommen…',
    rows: {
      skipped: 'Übersprungen',
      applied: 'Übernommen',
      failed: 'Nicht übernommen',
      changed: 'Inzwischen geändert',
      kept: 'Bleibt unverändert',
    },
    history: {
      amigo: 'Im Amigo-Protokoll öffnen',
      assistant: 'Im Protokoll des Assistenten öffnen',
    },
    undo: 'Rückgängig',
    to: 'zu',
    from: 'von',
    rejected: 'Abgelehnt',
    replaced: 'Ersetzt',
    expired: 'Abgelaufen',
  },
};
